import { createFileRoute } from "@tanstack/react-router"
import CollectionTasksTab from "~/components/collections/tabs/CollectionTasksTab"
import { OverviewPage } from "~/components/design-system/pages"
import { useCollectionContext } from "~/context/CollectionProvider"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/demand-planning/fashion/_layout/tasks")({
  component: RouteComponent,
})

function RouteComponent() {
  const { collections } = useCollectionContext()
  usePageTracking("Collections Tasks")

  const collectionIds = collections.map((c) => c.id)

  return (
    <OverviewPage fillContent>
      <CollectionTasksTab collectionIds={collectionIds} />
    </OverviewPage>
  )
}
